import React from 'react';
import getAvatar from '@teetsh/app/src/components/AvatarPicker/getAvatar';
import { UserIcon } from '@heroicons/react/24/outline';
import styled from '@emotion/styled';
import tw from 'twin.macro';
import clsx from 'clsx';
import FixedImg from '@teetsh/app/src/components/Img/FixedImg';

interface Props {
  picture?: string;
  className?: string;
  fill?: boolean;
  dimensions: {
    height: number;
    width: number;
  };
  isEditable?: boolean;
  userInitials?: string;
}

const AvatarIcon = styled.div`
  ${tw`h-full w-full`}
`;
export function Avatar(props: Props) {
  const { picture, className, dimensions, fill, isEditable, userInitials } =
    props;

  const width = dimensions.width;
  const height = dimensions.height;

  const avatar =
    picture && !picture.startsWith('users-attachments')
      ? getAvatar(picture)
      : picture;
  const isPicture =
    avatar &&
    typeof avatar === 'string' &&
    avatar.startsWith('users-attachments');
  if (isPicture) {
    return (
      <FixedImg
        className={clsx(className, 'avatar-img')}
        s3Path={avatar}
        width={width}
        height={height}
        options={{ focus: 'auto' }}
      />
    );
  }
  if ((!avatar || avatar === 'user') && !isEditable) {
    return (
      <div style={{ width, height }} className={className}>
        <div tw="size-full flex justify-center items-center">
          {userInitials && userInitials.length > 0 ? (
            <span tw="text-neutral-moderate text-sm">{userInitials}</span>
          ) : (
            <UserIcon tw="p-1 text-neutral-quiet" />
          )}
        </div>
      </div>
    );
  }
  return (
    <div
      css={[tw`flex flex-col justify-center`, !fill && tw`p-2`]}
      className={className}
      style={{ width, height }}
    >
      <AvatarIcon as={avatar} />
    </div>
  );
}
